import { Breakpoints, styled } from '@vw-marketing/us-components';

export const SytledMaintenanceContainer: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      height: auto;
      width: ${theme.size.grid024};
    `;
  }}
`;

export const StyledMaintenanceWrapper: any = styled.div`
  ${({ theme, carImage, showTabsWithMileage, isMileageInputted }) => {
    return `
      display: flex;
      flex-direction: column;
      padding: ${carImage ? theme.size.static500 : 0} ${theme.size.grid002} 0 ${theme.size.grid002};

      @media (min-width: ${Breakpoints.b1280}px) {
        gap: 40px;
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        flex-direction: row;
        gap: ${showTabsWithMileage || !isMileageInputted ? theme.size.grid002 : theme.size.grid001};
      }
    `;
  }}
`;

export const StyledMaintenanceLeftContainer: any = styled.div`
  display: flex;
  flex-direction: column;

  ${({ cardsAmount, showTabsWithMileage, theme, isMileageInputted }) => {
    return `
      min-width: ${showTabsWithMileage ? theme.size.grid006 : cardsAmount == 2 && isMileageInputted ? theme.size.grid007 : theme.size.grid006};
    `;
  }}
`;

export const StyledMaintenanceRightContainer: any = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCTAContainer: any = styled.div`
  padding-top: ${({ theme }) => theme.size.static250};
  width: max-content;

  @media (min-width: ${Breakpoints.b560}px) {
    padding-top: ${({ theme }) => theme.size.static300};
  }
`;

export const StyledCTAs = styled.div<{
  openCompleteView: boolean;
  isMileageInputted: boolean;
}>`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 20px;

  span {
    align-items: center;
    align-self: stretch;
    display: flex;
    justify-content: center;

    p {
      margin: 0;
      min-width: max-content;
    }

    button {
      text-align: center;
      min-width: max-content;
    }
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;
  }

  @media (min-width: ${Breakpoints.b1600}px) {
    align-items: ${({ openCompleteView, isMileageInputted }) => {
      if (!isMileageInputted) return 'flex-start';
      return !openCompleteView ? 'stretch' : 'flex-end';
    }};
    flex-direction: ${({ openCompleteView, isMileageInputted }) => {
      if (!isMileageInputted) return 'column';
      return !openCompleteView ? 'column' : 'row';
    }};
  }

  @media (min-width: ${Breakpoints.b1920}px) {
    align-items: center;
    flex-direction: row;
    justify-content: ${({ isMileageInputted }) => {
      return !isMileageInputted ? 'flex-start' : 'flex-end';
    }};
    ${({ openCompleteView, isMileageInputted }) => {
      return !openCompleteView && isMileageInputted && `button { flex: 1;}`;
    }};
  }
`;

interface WrapperProps {
  isCardWithinATab: boolean;
  theme: any;
}

export const StyledWrapper = styled.div<WrapperProps>`
  ${({ theme, isCardWithinATab }) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static400};
      padding-top: ${theme.size.static300};

      & [class^='StyledScrollWrapper-'],
      & [class*=' StyledScrollWrapper-'] {
        overflow: hidden !important;
      }

      & [class^='StyledLayer-'],
      & [class*=' StyledLayer-'] {
        margin-top: 56px !important;
        max-height: calc(100svh - 56px) !important;
        overflow-y: auto !important;

        // Hide the scroll bar
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */

        @media (min-width: ${Breakpoints.b560}px) {
          margin-top: 288px !important;
          max-height: calc(100vh - 288px) !important;
        }

        @media (min-width: ${Breakpoints.b1280}px) {
          margin-top: 90px !important;
          max-width: 1117px !important;
          max-height: 820px !important;
        }
      }
      
      @media (min-width: ${Breakpoints.b560}px) {
        gap: ${theme.size.static450};
        padding-top: ${theme.size.static350};
      }

      @media (min-width: ${Breakpoints.b1280}px) {     
        .scroll-buttons-wrapper {
          display: none;
        }
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        padding-top: 0;
      }

      ${
        isCardWithinATab &&
        `
        > div {
          width: 100%;
        }
      `
      };
    `;
  }}
`;

export const InfoCardsContainer: any = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ length }) => length}, 1fr);
  gap: ${({ theme }) => theme.size.static350};
`;

export const StyledTabsContainer: any = styled.div`
  ${({ theme, cardsLength, showTabsWithMileage }) => {
    return `
      padding-top: ${theme.size.static450};
      
      @media (min-width: ${Breakpoints.b560}px) {
        padding-top: ${theme.size.static500};
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        padding-top: 0;
        max-width: ${
          cardsLength === 3 && showTabsWithMileage
            ? theme.size.grid012
            : cardsLength === 3
              ? theme.size.grid014
              : theme.size.grid012
        };
      }

      & [class^='StyledTabsWrapper-'],
      & [class*='StyledTabsWrapper-'] {
        min-height: 50px !important;
      }

      & [class^='StyledTabBar-'],
      & [class*='StyledTabBar-'] {
        margin-block: 0 !important;
        column-gap: ${theme.size.static250} !important;
      }
    `;
  }}
`;
